const onRun = () => {
// Trip Weather
    const rows = document.querySelectorAll('.qtr');
    let highestTemperature = 0;

    rows.forEach(row => {
        const airTemperature = parseFloat(row.dataset.air);
        const waterTemperature = parseFloat(row.dataset.water);

        highestTemperature = Math.max(highestTemperature, airTemperature, waterTemperature);
    });

    let closestBiggerNumber = Math.ceil(highestTemperature / 10) * 10;

    if (closestBiggerNumber === highestTemperature) {
        closestBiggerNumber += 10;
    }

    // const tickValues = [];

    const tickElements = document.querySelectorAll('#ticks .tick');
    tickElements.forEach((tick, index) => {
        const tickValue = Math.ceil(closestBiggerNumber / 4 * (index + 1));
        // tickValues.push(tickValue);
        tick.querySelector('p').textContent = `${tickValue} °C`;
    });

    rows.forEach(row => {
        const airTemperature = parseFloat(row.dataset.air);
        const airHeight = (airTemperature / closestBiggerNumber);

        const waterTemperature = parseFloat(row.dataset.water);
        const waterHeight = (waterTemperature / closestBiggerNumber);

        row.querySelector('.air').style.height = `calc(((100%) * ${airHeight}) + 28px)`;
        row.querySelector('.water').style.height = `calc(((100%) * ${waterHeight}) + 28px)`;
    });
};
if(document.readyState !== 'loading') {
    onRun();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        onRun()
    });
}

